import { createSlice } from "@reduxjs/toolkit";

// The catalogue used by the home page and the featured rows (first 100 products)
const productSlice = createSlice({
    name: "product",
    initialState: {
        products: [],
        loading: true,
        error: null,
    },
    reducers: {
        setLoading: (state) => {
            state.loading = true;
            state.error = null;
        },
        setProducts: (state, action) => {
            state.products = action.payload;
            state.loading = false;
            state.error = null;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
    },
});

export const { setLoading, setProducts, setError } = productSlice.actions;
export const selectProducts = (state) => state.product.products;

export default productSlice.reducer;
